import {Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {NotifierService} from "angular-notifier";
import {UserService} from "../../../service/user.service";
import {BsModalService} from "ngx-bootstrap";
import {ImageCroppedEvent} from "ngx-image-cropper";

@Component({
  selector: 'app-destination',
  templateUrl: './destination.component.html',
  styleUrls: ['./destination.component.scss']
})
export class DestinationComponent implements OnInit {
  desti: any;
  form: any;
  @ViewChild("errorModal", {static: true}) errorModal;
  @ViewChild("addModal", {static: true}) addModal;
  up: boolean;
  upId: any;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  showCropper = false;
  imageCropper: any;
  resons: Array<any> = [];
  ty: string;
  page: any;
  totalRec: any;
  searchkey: any;
  searchform: any;

  constructor(private formBuilder: FormBuilder, private route: Router, private notifier: NotifierService,
              private userService: UserService, private modalService: BsModalService) {

    this.form = this.formBuilder.group({
      desc: ["", [Validators.required]],
      name: ["", [Validators.required]],
      reasons: ["",],
      why: ["", [Validators.required]],
    });

    this.searchform = this.formBuilder.group({
      search: ["", [Validators.required]],
    });
  }

  ngOnInit() {
    this.getAllDestination();
  }

  getAllDestination() {

    this.userService.getallDestinations().subscribe(
      res => {
        if (res.responseCode === 200) {
          this.desti = res.data;
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  search(pageIndex) {

    let size = 10;
    let page = pageIndex - 1;
    this.userService.searchDestinations(this.searchform.controls.search.value,size,page).subscribe(
      res=>{
        if (res.responseCode === 200) {
          this.desti =res['data']['content'];
          this.page = res['data']['number'];
          this.totalRec = res['data']['totalElements'];
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  new() {
    let req = {
      description: this.form.controls.desc.value,
      name: this.form.controls.name.value,
      reasonsList: this.resons,
      why: this.form.controls.why.value,
    }
    this.userService.createDestinations(req).subscribe(
      res => {
        if (res.responseCode === 200) {
          this.upload(res.data)
          this.notifier.notify('success', res.responseDesc);
          this.addModal.hide()
          this.getAllDestination();
          this.form.reset();
          this.imageChangedEvent = '';
          this.croppedImage = '';
          this.showCropper = false;
          this.imageCropper = '';
          this.resons=[];
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  window(up, obj) {
    this.ty = 'New'
    this.addModal.show();
    if (up == 'up') {
      this.ty = 'Update'
      this.up = true;
      this.upId = obj.id;
      this.form.controls['name'].setValue(obj.name);
      this.form.controls['desc'].setValue(obj.description);
      this.form.controls['why'].setValue(obj.why);
      this.resons=obj.reasonList;

    }
  }

  update() {
    let req = {
      id: this.upId,
      description: this.form.controls.desc.value,
      name: this.form.controls.name.value,
      reasonsList: this.resons,
      why: this.form.controls.why.value,
    }
    this.userService.createDestinations(req).subscribe(
      res => {
        if (res.responseCode === 200) {
          this.notifier.notify('success', res.responseDesc);
          this.up = false;
          this.upload(res.data)
          this.addModal.hide();
          this.getAllDestination();
          this.form.reset();
          this.imageChangedEvent = '';
          this.croppedImage = '';
          this.showCropper = false;
          this.imageCropper = '';
          this.resons=[];
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.file;
  }

  imageLoaded() {
    this.showCropper = true;
  }

  rotateLeft() {
    this.imageCropper.rotateLeft();
  }

  rotateRight() {
    this.imageCropper.rotateRight();
  }

  flipHorizontal() {
    this.imageCropper.flipHorizontal();
  }

  flipVertical() {
    this.imageCropper.flipVertical();
  }

  upload(id) {
    this.userService.destinationImgUpload(this.croppedImage, id).subscribe(
      data => {
        if (data.responseCode == 200) {
          this.notifier.notify('success', data.responseDesc);
          this.getAllDestination();
        } else {
          this.notifier.notify('danger', 'Somthing went wrong faild to upload image.');
        }
      });
  }

  delete(id) {
    this.userService.deleteUni(id).subscribe(
      res => {
        if (res.responseCode == 200) {
          this.notifier.notify('success', res.responseDesc);
          this.getAllDestination();
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  resonArray() {
    this.resons.push({
      reason: this.form.controls.reasons.value,
    });
    this.form.controls['reasons'].setValue('');
  }

  deleteReason(id) {
    for (let i = 0; i < this.resons.length; ++i) {
      if (this.resons[i].reason === id) {
        this.resons.splice(i, 1);
      }
    }
  }
}
